import {FormHelperText} from '@material-ui/core';
import {ReactNode} from 'react';
import PhoneInput, {Props} from 'react-phone-number-input';
import clsx from 'clsx';

const PhoneNumberField = ({
    error,
    helperText,
    fullWidth,
    ...props
}: Props & {
    error?: boolean;
    helperText?: ReactNode;
    fullWidth?: boolean;
    label?: ReactNode;
}) => {
    const {className, disabled, label} = props;
    const phoneInputProps = props as Props;
    const widthStyle = {width: fullWidth ? '100%' : '300px'};
    const labelText =
        typeof label === 'string' || typeof label === 'number'
            ? label
            : undefined;

    return (
        <div
            style={widthStyle}
            className={clsx('phoneInputFieldWrapper', className, {
                phoneInputFullWidth: fullWidth,
                errorBorder: error,
                phoneInputDisabled: disabled,
            })}
        >
            <PhoneInput
                {...phoneInputProps}
                error={error}
                defaultCountry="PL"
                className="phoneInputRoot"
                withCountryCallingCode
            />
            <fieldset aria-hidden className="phoneInputOutline">
                <legend className="phoneInputLegend">
                    <span>{labelText || '\u200B'}</span>
                </legend>
            </fieldset>
            <FormHelperText
                variant="outlined"
                error={error}
                style={widthStyle}
            >
                {helperText}
            </FormHelperText>
        </div>
    );
};

export default PhoneNumberField;
